<template>
    <div>
        <tabs class="ses-tabs" :fill="0" :pills="0" :activeTab="0">
            <card shadow>

                <tab-pane :key="0" title="Categories" :id="0">
                    <div class="row">
                        <div class="col-lg-12">
                            <form @submit.prevent="add_category">
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control" placeholder="New Category" v-model="category_name" required>
                                    <button class="btn ml-2" type="submit">Add</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <form @submit.prevent="save_categories">
                        <div class="row mt-4">
                            <div class="col-lg-12">
                                <div class="mb-1">
                                    <button class="btn px-2 py-0" type="button" @click="unfold_all_category(categories)"><span class="fa fa-plus"></span></button>
                                    <button class="btn px-2 py-0" type="button" @click="fold_all_category(categories)"><span class="fa fa-minus"></span></button>
                                </div>
                                <Tree :value="categories">
                                    <span slot-scope="{node, path, tree}">
                                        <div class="d-flex align-items-center">
                                            <span class="fa fa-th mr-2"></span>
                                            <template v-if="node.children.length > 0">
                                                <span @click="tree.toggleFold(node, path)" class="fa mr-2" :class="[node.$folded ? 'fa fa-plus' : 'fa-minus']"></span>
                                            </template>
                                            <input type="text" class="node-name" v-model="node.name" required>
                                            <a href="javascript:void(0);" class="node-remove" v-if="!node.id || node.children.length == 0" @click="remove_category(node.id); tree.removeNodeByPath(path);"><span class="fa fa-remove"></span></a>
                                        </div>
                                    </span>
                                </Tree>
                            </div>
                        </div>
                        <div class="row mt-4">
                            <div class="col-lg-12">
                                <button class="btn btn-black" type="submit" :disabled="isSubmitting">
                                    <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                                    <template v-else>Save</template>
                                </button>
                            </div>
                        </div>
                    </form>
                </tab-pane>

                <tab-pane :key="1" title="Spare Parts" :id="1">
                    <div class="row">
                        <div class="col-lg-12">
                            <button class="btn btn-black float-right" type="button" @click="add_item">Add New</button>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-lg-12">
                            <div class="filter-wrapper">
                                <p class="title">Manage Filters:</p>
                                <div class="filter-container">
                                    <div class="filter-item">
                                        <select class="nice-select" v-model="filters.product_type" @change="get_product_models(); get_part_types(); filter_list();">
                                            <option value="all">Product Type: All</option>
                                            <option v-for="(row, key) in product_types" :key="key" :value="row.id">{{ row.name }}</option>
                                        </select>
                                    </div>
                                    <div class="filter-item">
                                        <select class="nice-select" v-model="filters.product_model" @change="get_product_numbers(); filter_list();">
                                            <option value="all">Product Model: All</option>
                                            <option v-for="(row, key) in product_models" :key="key" :value="row.id">{{ row.name }}</option>
                                        </select>
                                    </div>
                                    <div class="filter-item">
                                        <select class="nice-select" v-model="filters.product_number" @change="filter_list">
                                            <option value="all">Product Number: All</option>
                                            <option v-for="(row, key) in product_numbers" :key="key" :value="row.id">{{ row.name }}</option>
                                        </select>
                                    </div>
                                    <div class="filter-item">
                                        <select class="nice-select" v-model="filters.part_type" @change="filter_list">
                                            <option value="all">Part Type: All</option>
                                            <option v-for="(row, key) in part_types" :key="key" :value="row.id">{{ row.name }}</option>
                                        </select>
                                    </div>
                                    <div class="filter-item search-filter">
                                        <input type="text" placeholder="Search" v-model="filters.search" @change="filter_list">
                                        <button type="button" @click="filter_list"><i class="fa fa-search"></i></button>
                                    </div>
                                    <div class="filter-reset-btn">
                                        <a href="javascript:void(0)" title="Refresh" @click="reset_filter">
                                            <i class="fa fa-refresh reset-icon" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="table-responsive">
                                <div id="ses-list" class="list-proj" @scroll="scroll_list">
                                    <div class="row list-head">
                                        <div class="col" data-key="item" @click="sort_list">TDI PART #</div>
                                        <div class="col" data-key="description" @click="sort_list">Description</div>
                                        <div class="col sort-false">Picture</div>
                                        <div class="col" data-key="price" @click="sort_list">Price</div>
                                    </div>
                                    <div class="list-row" v-for="row in spare_parts" :key="row.id">
                                        <div class="row list-data">
                                            <div class="col">{{ row.item }}</div>
                                            <div class="col">{{ row.description }}</div>
                                            <div class="col">
                                                <div class="image-wrap">
                                                    <img :src="row.image ? row.image : '/api/public/img/item-placeholder.png'" class="image">
                                                </div>    
                                            </div>
                                            <div class="col">${{ row.price }}</div>
                                        </div>
                                        <div class="row list-action">
                                            <div class="col-md-12 text-right">
                                                <a href="javascript:void(0);" @click="edit_item(row.id)">Edit</a>
                                                <a href="javascript:void(0);" @click="delete_item(row.id)">Delete</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="spare_parts.length == 0 && !isListLoading">
                                    <p class="no-results-msg">No results found</p>
                                </template>
                                <template v-if="isListLoading">
                                    <div class="progress">
                                        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                </tab-pane>
            
            </card>
        </tabs>

        <!-- Item Modal -->
        <modal :show="showItemModal" @close="closeItemModal" :closeOnbackdrop="false">
            <template slot="header"><h3>{{ item_model.id ? 'Edit Item' : 'New Item' }}</h3></template>
            <template>
                <div class="row">
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Item Name <span class="required-indicator">*</span></label>
                                    <input type="text" class="form-control" ref="item" v-model="item_model.item">
                                </div>
                                <div class="form-group">
                                    <label>Image</label>
                                    <input type="file" class="form-control" ref="item_image_file" @change="on_select_file($event, 'item_image')" accept="image/*">
                                    <div class="text-center mt-4">
                                        <img v-if="item_image" :src="item_image" style="width: 100%;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Categories</label>
                                    <div class="mt-1 mb-1">
                                        <button class="btn px-2 py-0" type="button" @click="unfold_all_category(item_categories)"><span class="fa fa-plus"></span></button>
                                        <button class="btn px-2 py-0" type="button" @click="fold_all_category(item_categories)"><span class="fa fa-minus"></span></button>
                                    </div>
                                    <Tree :value="item_categories" :draggable="false">
                                        <span slot-scope="{node, tree}">
                                            <div class="d-flex align-items-center">
                                                <input type="checkbox" class="mr-2" :checked="item_model.categories.includes(node.id)" @change="select_item_category($event, node)" />
                                                <template v-if="node.children.length > 0">
                                                    <span @click="tree.toggleFold(node, path)" class="fa mr-2" :class="[node.$folded ? 'fa fa-plus' : 'fa-minus']"></span>
                                                </template>
                                                {{ node.name }}
                                            </div>
                                        </span>
                                    </Tree>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-black" type="button" :disabled="isSubmitting" @click="save_item">
                    <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                    <template v-else>Save</template>
                </button>
            </template>
        </modal>

    </div>
</template>
<script>
import { 
    Tree,
    Fold, Draggable, // plugins
    foldAll, unfoldAll //, cloneTreeData, walkTreeData, getPureTreeData, // utils
} 
from 'he-tree-vue'
import 'he-tree-vue/dist/he-tree-vue.css'

export default {
    components: { 
        Tree: Tree.mixPlugins([Fold, Draggable])
    },
    data() {
        return {
            isListLoading: false,
            isSubmitting: false,
            showItemModal: false,
            spare_parts: [],
            product_types: [],
            product_models: [],
            product_numbers: [],
            part_types: [],
            page: 1,
            last_page: 1,
            order_by: 'item',
            order: 'asc',
            filters: {
                search: '',
                product_type: 'all',
                product_model: 'all',
                product_number: 'all',
                part_type: 'all'
            },
            categories: [],
            category_name: '',
            to_delete_category: [],
            item_model: {
                id: '',
                item: '',
                image: '',
                categories: [],
                to_delete_category: []
            },
            item_image: '',
            item_image_file: '',
            item_categories: []
        }
    },
    mounted() {
        this.get_categories()
        this.get_spare_parts()
        this.get_product_types()
    },
    methods: {
        add_category() {
            if(this.category_name) {
                this.categories.push({
                    id: '',
                    name: this.category_name,
                    parent: 0,
                    children: []
                })
                this.category_name = ''
            }
        },
        remove_category(id) {
            if(id) {
                this.to_delete_category.push(id)
            }
        },
        save_categories() {
            this.isSubmitting = true

            this.$http.post('/api/product_categories/save_all', { categories: JSON.stringify(this.categories), to_delete_category: this.to_delete_category })
                .then((response) => {
                    this.categories = response.data.data
                    this.isSubmitting = false
                    this.to_delete_category = []
                    foldAll(this.categories)
                    alert('Saved!')
                })
                .catch(() => {
                    this.isSubmitting = false
                    alert('Something went wrong!')
                })
        },
        get_spare_parts() {
            this.isListLoading = true
            this.$http.get('/api/spare-parts?page=' + this.page 
                    + '&order_by=' + this.order_by
                    + '&order=' + this.order
                    + '&filters=' + JSON.stringify(this.filters)
                )
                .then((response) => {
                    if(this.page == 1) {
                        this.spare_parts = []
                    }
                    response.data.data.forEach(row => {
                        this.spare_parts.push(row)
                    })
                    this.last_page = response.data.last_page
                    this.isListLoading = false
                })
        },
        get_product_types() {
            this.product_types = []
            this.filters.part_type = 'all'

            this.$http.get('/api/product_categories/children/Product Type')
                .then((response) => {
                    this.product_types = response.data
                })
        },
        get_product_models() {
            this.filters.product_model = 'all'
            this.filters.product_number = 'all'
            this.product_models = []

            if(this.filters.product_type != 'all') {
                this.$http.get('/api/product_categories/children/' + this.filters.product_type)
                    .then((response) => {
                        this.product_models = response.data
                    })
            }
        },
        get_product_numbers() {
            this.filters.product_number = 'all'
            this.product_numbers = []

            if(this.filters.product_model != 'all') {
                this.$http.get('/api/product_categories/children/' + this.filters.product_model)
                    .then((response) => {
                        this.product_numbers = response.data
                    })
            }
        },
        get_part_types() {
            this.filters.part_type = 'all'
            this.part_types = []

            if(this.filters.product_type != 'all') {
                this.$http.get('/api/product_categories/children/Part Type?product_type=' + this.filters.product_type)
                    .then((response) => {
                        this.part_types = response.data
                    })
            }
        },
        get_categories(action = null) {
            this.$http.get('/api/product_categories')
                .then((response) => {
                    if(action == 'item') {
                        this.item_categories = response.data
                        foldAll(this.item_categories)
                    } else {
                        this.categories = response.data
                        foldAll(this.categories)
                    }
                })
        },
        add_item() {
            this.showItemModal = true
            this.get_categories('item')
        },
        edit_item(id) {
            this.item_model.id = id
            this.$http.get('/api/spare-parts/' + this.item_model.id)
                .then((response) => {
                    this.item_model = response.data.data
                    this.item_model.categories = response.data.categories
                    this.item_model.to_delete_category = []
                    this.item_image = this.item_model.image
                    
                    this.showItemModal = true
                    this.get_categories('item')
                })
        },
        delete_item(id) {
            if(id) {
                let conf = confirm('Are you sure you want to permanently delete this item?')
                if(conf) {
                    this.$http.delete('/api/spare-parts/' + id)
                        .then(() => {
                            this.get_spare_parts()
                            alert('Deleted!')
                        })
                }
            }
        },
        save_item() {
            let fdata = new FormData()
            this.isSubmitting = true

            fdata.append('id', this.item_model.id)
            fdata.append('item', this.item_model.item)
            fdata.append('image', this.item_image_file)
            for(let x in this.item_model.categories) {
                fdata.append('categories[]', this.item_model.categories[x])
            }
            for(let x in this.item_model.to_delete_category) {
                fdata.append('to_delete_category[]', this.item_model.to_delete_category[x])
            }

            this.$http.post('/api/spare-parts', fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(() => {
                    this.isSubmitting = false
                    this.closeItemModal()
                    this.get_spare_parts()
                    alert('Saved!')
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                    }
                    this.isSubmitting = false
                })
        },
        select_item_category(e, node) {
            if(e.target.checked) {
                if(this.item_model.categories.indexOf(node.id) == -1) {
                    this.item_model.categories.push(node.id)
                }
                this.item_model.to_delete_category.splice( this.item_model.to_delete_category.indexOf(node.id), 1 )
            } else {
                this.item_model.categories.splice( this.item_model.categories.indexOf(node.id), 1 )
                if(this.item_model.to_delete_category.indexOf(node.id) == -1) {
                    this.item_model.to_delete_category.push(node.id)
                }
            }
        },
        closeItemModal() {
            this.showItemModal = false
            this.item_model = {
                id: '',
                item: '',
                image: '',
                categories: [],
                to_delete_category: []
            }
            this.item_image = ''
            this.item_image_file = ''
        },
        unfold_all_category(categories) {
            unfoldAll(categories)
        },
        fold_all_category(categories) {
            foldAll(categories)
        },
        scroll_list(e) {
            if(e.target.scrollTop + e.target.clientHeight >= (e.target.scrollHeight - 50) && !this.isListLoading) {
                this.page += 1
                if(this.page <= this.last_page) {
                    this.get_spare_parts()
                }
            }
        },
        sort_list(e) {
            if(!this.isListLoading) {
                Array.from(document.querySelectorAll('#ses-list .list-head .col')).forEach((el) => {
                    el.classList.remove('asc', 'desc')
                })
                let element = document.querySelector('#ses-list .list-head .col[data-key='+e.target.dataset.key+']')
                this.order_by = e.target.dataset.key
                this.order = element.dataset.order || 'asc'
                element.classList.add(this.order)
                element.dataset.order = (this.order == 'asc' ? 'desc' : 'asc')
                this.page = 1
                this.spare_parts = []
                this.get_spare_parts()
            }
        },
        filter_list() {
            this.page = 1
            this.spare_parts = []
            this.get_spare_parts()
        },
        reset_filter() {
            this.filters = {
                search: '',
                product_type: 'all',
                product_model: 'all',
                product_number: 'all',
                part_type: 'all'
            }
            this.product_models = []
            this.product_numbers = []
            this.part_types = []
            this.page = 1
            this.spare_parts = []
            this.get_spare_parts()
        },
        on_select_file(event, key) {
            const files = event.target.files
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this[key] = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this[`${key}_file`] = files[0]
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError')
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            } else {
                alert('Please fill all required data.')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
#ses-list {
    min-width: 700px;
    padding-right: 12px;
    .list-head .col {
        display: flex;
        justify-content: center;
        align-items: center;
        background-image: url('/api/public/img/bg.png');
        background-position: center right;
        background-repeat: no-repeat;
        cursor: pointer;
        white-space: normal;
        &.asc {
            background-image: url('/api/public/img/trans-asc.png');
        }
        &.desc {
            background-image: url('/api/public/img/trans-desc.png');
        }
        &.sort-false {
            background-image: none;
            cursor: default;
        }
    }
}
.progress {
    border-radius: 0;
}
.no-results-msg {
    text-align: center;
    padding: 0.5em;
    font-size: 11px;
}
.image-wrap {
    position: relative;
    width: 60px;
    height: 60px;
    margin: 0 auto;
    .image {
        width: 60px;
        height: 60px;
        &:hover {
            width: 240px;
            height: auto;
            border: 2px solid #ccc;
            z-index: 999;
            position: absolute;
            transform: translate(-50%, -10%);
        }
    }
}
.node-name {
    border: 0;
    padding: 0.2em;
    width: 100%;
}
.node-remove {
    float: right;
    margin-left: 4px;
}
.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.list-proj .row .action-wrap { white-space: nowrap; position: relative; z-index: 2; text-align: left; }
.list-proj .row .action { display: inline-block; text-align: center; height: 30px; padding: 7px; border: 0; letter-spacing: 0.3px; color: #fff; text-decoration: none; min-width: 86px; cursor: pointer; color: #fff; background-color: #5cb85c; margin-left: 6px; vertical-align: middle; }
.list-proj .row .action span { display: inline-block; background: #459e45; padding: 2px 7px; width: 29px; margin: -7px 2px -7px -8px; font-size: 17px; line-height: 26px; text-align: center; }
.list-proj .row .action.action-blue { background: #337ab7; }
.list-proj .row .action.action-blue span { background: #055091; }
@media (min-width: 1200px) {
    .filter-wrapper {
        .filter-item {
            width: 24.6% !important;
        }
    }
}
</style>